import { render, staticRenderFns } from "./ApproveBottom.vue?vue&type=template&id=67b089b6&scoped=true&"
import script from "./ApproveBottom.vue?vue&type=script&lang=js&"
export * from "./ApproveBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b089b6",
  null
  
)

export default component.exports